import type { CartDeliveryLadderOption } from "@/api/queries/cart";

/**
 * KAN-1901 — klíč textu „termín potvrdíme" podle důvodu, proč datum chybí
 * (namespace ``checkout``). Chybějící materiál bez dodací lhůty má vlastní,
 * lidštější větu; krok bez odhadu doby (KAN-1438) obecné „Termín upřesníme".
 *
 * Žije mimo ``@/api/queries/cart`` schválně: testy pokladny ten modul mockují
 * pevným seznamem exportů a čistá funkce by v nich chyběla.
 */
export function pendingDateKey(
  opt: Pick<CartDeliveryLadderOption, "eta_pending_reason">,
): "deliveryDatePending" | "deliveryDatePendingMaterial" {
  return isMaterialPending(opt)
    ? "deliveryDatePendingMaterial"
    : "deliveryDatePending";
}

/** KAN-1901 — datum chybí kvůli materiálu bez dodací lhůty. Jediné místo,
 * kde FE ten důvod rozpoznává (pokladna i souhrn košíku). Operace bez
 * termínů (KAN-1922) důvod nenese a zůstává u obecného „Termín upřesníme". */
export function isMaterialPending(
  opt: Pick<CartDeliveryLadderOption, "eta_pending_reason">,
): boolean {
  return opt.eta_pending_reason === "material_lead_time";
}
